// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1pyia","title":"style_title__2P7rT","content":"style_content__1r7qP"};